import { IANAZone } from "luxon";

import { DateTime } from "../Types/DateTime";

/** The type of a Block. */
export enum BlockType {
  /** This block is available for scheduling. */
  Open = 0,
  /** This block has been reserved by another user for assignment, but is open on the Zenoti calendar. */
  Reserved = 1,
  /** The block contains an appointment object on the zenoti calendar. */
  Booked = 2,
  /** The block contains a "block" object on the Zenoti calendar. */
  Blocked = 3
}

/** An object representing a span of time on the Zenoti schedule. */
export class Block {
  /** The start time of the timespan in utc. */
  startTimeUtc!: string;
  /** The end time of the timespan in utc. */
  endTimeUtc!: string;
  /** The type of timespan being described by this object. */
  type!: BlockType;
}

/** A Block from the CRM including advanced objects for local logic. */
export class EnhancedBlock extends Block {
  /** The UTC DateTime object for the block start time. */
  startTime: DateTime;
  /** The UTC DateTime object for the block end time. */
  endTime: DateTime;

  constructor(block: Block, zone: IANAZone) {
    super();

    this.type = block.type;
    this.startTimeUtc = block.startTimeUtc;
    this.endTimeUtc = block.endTimeUtc;
    this.startTime = DateTime.fromISO(block.startTimeUtc, { zone: zone.name });
    this.endTime = DateTime.fromISO(block.endTimeUtc, { zone: zone.name });
  }
}
